module.exports = __webpack_public_path__ + "img/DondeQuedarse.9f50300b.svg";